import './style.scss'
const PATH = process.env.PUBLIC_URL

function Header({ background, logo }) {
    const logosrc = logo || `${PATH}/logo.svg`
    const bgsrc = background || `${PATH}/header-bg.jpg`
    return (
        <div className="header">
            <div className="header__logo">
                <img src={logosrc} alt="" />
            </div>

            <div className="header__bg">
                <img src={bgsrc} alt="" />
            </div>
        </div>
    )
}

export default Header
